'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTdGrade = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTdGrade, _Component);

  //
  function IyvListTdGrade(props) {
    (0, _classCallCheck3.default)(this, IyvListTdGrade);

    //
    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListTdGrade.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdGrade)).call(this, props));

    var _props$shareclass = props.shareclass,
        ticker = _props$shareclass.ticker,
        fund_legal_name = _props$shareclass.fund_legal_name,
        fund_id = _props$shareclass.fund_id,
        investment_vehicle_id = _props$shareclass.investment_vehicle_id;

    // make ticker safe for URL

    var sTicker = ticker || 'N';

    var urlBuilder = function urlBuilder(route, profilePath) {
      return route + '/' + _format2.default.sanitize(fund_legal_name) + '/' + sTicker + '/' + profilePath + '/' + fund_id + '/' + investment_vehicle_id;
    };

    var urlOutsideSite = null;
    var title = null;

    // switch logic on fieldName
    switch (props.fieldName) {
      case 'grade_fossil':
        if (_config2.default.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.fff + _config2.default.routes.fund, 'fossil-fuel-investments');
          title = props.shareclass.name + ' | Fossil Free Funds';
        }
        break;
      case 'grade_fossil_bank':
        if (_config2.default.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.fff + _config2.default.routes.fund, 'fossil-finance-insurance');
          title = props.shareclass.name + ' | Fossil Free Funds';
        }
        break;
      case 'grade_fossil_insure':
        if (_config2.default.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.fff + _config2.default.routes.fund, 'fossil-finance-insurance');
          title = props.shareclass.name + ' | Fossil Free Funds';
        }
        break;
      case 'grade_deforestation':
        if (_config2.default.app.title !== 'Deforestation Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.dff + _config2.default.routes.fund, 'profile');
          title = props.shareclass.name + ' | Deforestation Free Funds';
        }
        break;
      case 'grade_gender_equality':
        if (_config2.default.app.title !== 'Gender Equality Funds' && _config2.default.app.title !== 'Social Justice Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.gef + _config2.default.routes.fund, 'gender-lens-score');
          title = props.shareclass.name + ' | Gender Equality Funds';
        }
        break;
      case 'grade_dei':
        if (_config2.default.app.title !== 'Social Justice Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.sjf + _config2.default.routes.fund, 'profile');
          title = props.shareclass.name + ' | Social Justice Funds';
        }
        break;
      case 'grade_rji':
        if (_config2.default.app.title !== 'Social Justice Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.sjf + _config2.default.routes.fund, 'profile');
          title = props.shareclass.name + ' | Social Justice Funds';
        }
        break;
      case 'grade_hrc':
        if (_config2.default.app.title !== 'Social Justice Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.sjf + _config2.default.routes.fund, 'profile');
          title = props.shareclass.name + ' | Social Justice Funds';
        }
        break;
      case 'grade_military':
        if (_config2.default.app.title !== 'Weapon Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.wff + _config2.default.routes.fund, 'weapon-investments');
          title = props.shareclass.name + ' | Weapon Free Funds';
        }
        break;
      case 'grade_guns':
        if (_config2.default.app.title !== 'Gun Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.gff + _config2.default.routes.fund, 'gun-investments');
          title = props.shareclass.name + ' | Gun Free Funds';
        }
        break;
      case 'grade_prison_industrial_complex':
        if (_config2.default.app.title !== 'Prison Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.pff + _config2.default.routes.fund, 'prison-industrial-complex-investments');
          title = props.shareclass.name + ' | Gun Free Funds';
        }
        break;
      case 'grade_tobacco':
        if (_config2.default.app.title !== 'Tobacco Free Funds') {
          urlOutsideSite = urlBuilder(_config2.default.links.tff + _config2.default.routes.fund, 'tobacco-profile');
          title = props.shareclass.name + ' | Tobacco Free Funds';
        }
        break;
      default:
        break;
    }
    //
    _this.state = {
      urlOutsideSite: urlOutsideSite,
      title: title
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListTdGrade, [{
    key: 'render',
    value: function render() {
      //
      if (this.state.urlOutsideSite) {
        return _react2.default.createElement(
          'td',
          { styleName: 'col col-grade' },
          _react2.default.createElement(
            _components.Link,
            {
              to: this.state.urlOutsideSite,
              title: this.state.title
            },
            _react2.default.createElement(
              'div',
              { styleName: 'score-wrapper' },
              _react2.default.createElement(_components.Grade, { grade: this.props.shareclass[this.props.fieldName], square: true })
            )
          )
        );
      }
      //
      return _react2.default.createElement(
        'td',
        {
          styleName: 'col col-grade',
          onClick: this.props.fieldName === 'grade_fossil_bank' || this.props.fieldName === 'grade_fossil_insure' ? this.props.clickShareclass(this.props.shareclass, 'fossil-finance-insurance') : this.props.clickShareclass(this.props.shareclass)
        },
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper' },
          _react2.default.createElement(_components.Grade, { grade: this.props.shareclass[this.props.fieldName], square: true })
        )
      );
    }
  }]);
  return IyvListTdGrade;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired,
  fieldName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = IyvListTdGrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdGrade.js
// module id = 1379
// module chunks = 0